/* eslint-disable no-mixed-operators */
import * as React from 'react';
import { Dropdown } from '@fluentui/react/lib/Dropdown';
import Color from '../../../core/libraries/Color';
import Template from '../../../core/libraries/Template';
import Constants from '../../../core/libraries/Constants';
import { connect } from 'react-redux';
import _ from 'lodash';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import RbButton, { ButtonSize } from '../../../bosch-react/components/button/RbButton';
import { confirmDialog, showDialog, showToastMessage } from '../../Dialog/actions';
import { RootState } from '../../../store/store';
import { IUserProfile } from '../../Auth/types';
import CustomizedPeoplePicker from '../../../core/components/PeoplePicker/CustomizedPeoplePicker';
import { PrincipalType } from '../../../core/components/PeoplePicker/types';
import { IGetOrgInfoReq, Organization, QueryTypeEnums } from '../../../services/type';
import { getDirectDeps } from '../../../services/idmServices';
import { ILowerFirstCaseMetadata } from '../../AccessMediator/types';
import Helper from '../../../core/libraries/Helper';
import RbLoadingSpinner from '../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import { IPersonaProps, TextField } from '@fluentui/react';

interface MoveReport_MoveInformationProps {
    userProfile: IUserProfile | undefined,
    confirmDialog: typeof confirmDialog,
    showDialog: typeof showDialog,
    showToastMessage: typeof showToastMessage,
    moveItem: ILowerFirstCaseMetadata | null,
    srcItem: ILowerFirstCaseMetadata | null,
    move: () => void,
    updateMoveItem: any,
    updateIsValidDept: any
}

interface IState {
    selectedTargetDivision: any,
    selectedTargetDepartment: any,
    isCheckingDepartment: boolean,
    rou: Organization | null,
    selectedUploadType: string,
    selectedSecurityClass: string,
    errorMessage: string,
}

class MoveReport_MoveInformation extends React.Component<MoveReport_MoveInformationProps, IState> {
    changeDeptRef: React.RefObject<any> = React.createRef()

    constructor(props: MoveReport_MoveInformationProps) {
        super(props);

        this.state = {
            selectedTargetDivision: null,
            selectedTargetDepartment: null,
            isCheckingDepartment: false,
            rou: null,
            selectedUploadType: this.props.moveItem?.uploadType ?? "",
            selectedSecurityClass: this.props.moveItem?.securityClass ?? "",
            errorMessage: "",
        };
        this.renderToDivision = this.renderToDivision.bind(this);
        this.renderToDepartment = this.renderToDepartment.bind(this);
        this.renderToUploadType = this.renderToUploadType.bind(this);
        this.renderToSecurityClass = this.renderToSecurityClass.bind(this);
        this.check = this.check.bind(this);
        this.move = this.move.bind(this);
    }

    render() {
        let element = (
            <div className="ms-Grid">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <RbLabel style={{ color: Color.BLUE }}><h4 style={{ marginBottom: "0px" }}>Move Information</h4></RbLabel>
                    </div>
                </div>
                {this.renderToDivision()}
                {this.renderToDepartment()}
                {this.renderToUploadType()}
                {this.renderToSecurityClass()}
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <br />
                        <RbButton label="Move" size={ButtonSize.Small} onClick={this.move} />
                        <br />
                    </div>
                </div>
            </div>
        );
        return element;
    }

    renderToDivision() {
        const { selectedTargetDivision, isCheckingDepartment } = this.state
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "To division",
                    <TextField
                        errorMessage={!selectedTargetDivision && !isCheckingDepartment ? "This field is based on the department name you entered." : ""}
                        placeholder="Generated from department"
                        disabled={true}
                        value={selectedTargetDivision || ""}
                    />, false, 4, 8, 11)}
            </div>
        );
    }

    onChangeDepartment(persona: IPersonaProps[]) {
        let items = !!this.changeDeptRef && this.changeDeptRef.current.getSelectedItems() || [];
        let results: any[] = [];
        if (items.length > 0) {
            items.forEach((item: any) => {
                !!item.displayName && results.push(item.displayName);
            })
            this.setState({
                selectedTargetDepartment: results[0]
            }, () => {
                this.props.updateMoveItem('department', this.state.selectedTargetDepartment)
            })
        }
        else {
            this.setState({
                selectedTargetDepartment: "",
                selectedTargetDivision: "",
                rou: null
            }, () => {
                this.props.updateIsValidDept(false)
            })
        }
        this.props.updateMoveItem('preSelectedDepartment', persona)
    }

    renderToDepartment() {
        const { isCheckingDepartment, selectedTargetDepartment } = this.state
        return (
            <div className="ms-Grid-row">
                {Template.renderCommonTemplate(
                    "To department",
                    <CustomizedPeoplePicker
                        itemLimit={1}
                        defaultValue={!!this.props.moveItem?.preSelectedDepartment ? this.props.moveItem?.preSelectedDepartment : []}
                        errorMessage={!selectedTargetDepartment && !isCheckingDepartment ? "Please select a department then click Check" : ""}
                        principalType={PrincipalType.Group}
                        componentRef={this.changeDeptRef}
                        onChange={(persona: IPersonaProps[]) => this.onChangeDepartment(persona)}
                    />
                    , false, 4, 8, 11)}
                {Template.renderCommonTemplate("",
                    <div>
                        {/* Buttons */}
                        {(!isCheckingDepartment) && <>
                            <RbButton label="Check" size={ButtonSize.Small} disabled={isCheckingDepartment} onClick={this.check} />
                        </> || <RbLoadingSpinner />}
                        {/* Messages */}
                        {!!this.state.errorMessage && <RbLabel style={{ color: Color.RED }}>
                            {this.state.errorMessage}
                        </RbLabel>}
                        {!!this.state.rou && <RbLabel style={{ color: Color.GREEN }}>
                            Valid department
                        </RbLabel>}
                    </div>, false, 4, 8, 11)}
            </div>
        );
    }

    renderToUploadType() {
        if ((this.props.srcItem?.uploadType === Constants.UPLOAD_TYPE.RnD || this.props.srcItem?.uploadType === Constants.UPLOAD_TYPE.LL)) {
            return (
                <div className="ms-Grid-row">
                    {Template.renderCommonTemplate(
                        "To upload type",
                        <Dropdown
                            selectedKey={this.state.selectedUploadType}
                            placeholder="Choose upload type ..."
                            options={Constants.DD_UPLOAD_TYPES_FOR_ADMIN_MOVE}
                            onChange={(event, option) => {
                                if (!!option) {
                                    this.setState({ selectedUploadType: option.key.toString() });
                                    this.props.updateMoveItem('uploadType', option.key);
                                }
                            }}
                        />, false, 4, 8, 11)}
                </div>
            );
        }
        return "";
    }

    renderToSecurityClass() {
        if (this.props.moveItem?.uploadType === Constants.UPLOAD_TYPE.Thesis) {
            return (
                <div className="ms-Grid-row">
                    {Template.renderCommonTemplate(
                        "To security class",
                        <Dropdown
                            selectedKey={this.state.selectedSecurityClass}
                            placeholder="Choose security class ..."
                            options={Constants.DD_SECURITY_CLASSES_ONLY_2_ALL}
                            onChange={(event, option) => {
                                !!option && this.setState({
                                    selectedSecurityClass: option.key.toString()
                                }, () => {
                                    this.props.updateMoveItem("securityClass", this.state.selectedSecurityClass)
                                });
                            }}
                        />, false, 4, 8, 11)}
                </div>
            );
        }
        return "";
    }

    check() {
        let { selectedTargetDepartment } = this.state
        !!selectedTargetDepartment ?
            this.setState({
                isCheckingDepartment: true,
                errorMessage: ""
            }, async () => {
                // Get ROU Id
                let req: IGetOrgInfoReq = {
                    identitiesOrOrgNames: [selectedTargetDepartment],
                    queryType: QueryTypeEnums.OrgNames
                }
                let depts = await getDirectDeps(req)
                if (!!depts && depts.length > 0) {
                    let org = depts[0] as Organization
                    let newDestination: ILowerFirstCaseMetadata = {
                        uploadType: this.state.selectedUploadType,
                        department: org.orgName,
                        division: org.division
                    }
                    let hasPermissionOnNewDestination = Helper.checkHasPermissionOnDocument(newDestination, this.props.userProfile);
                    if (hasPermissionOnNewDestination) {
                        this.setState({
                            selectedTargetDepartment: newDestination.department,
                            selectedTargetDivision: newDestination.division,
                            isCheckingDepartment: false,
                            rou: org,
                            errorMessage: ""
                        }, () => {
                            this.props.updateMoveItem('division', newDestination.division)
                            this.props.updateMoveItem('department', newDestination.department)
                            this.props.updateIsValidDept(true);
                        })

                    }
                    else {
                        this.setState({
                            selectedTargetDepartment: "",
                            selectedTargetDivision: "",
                            isCheckingDepartment: false,
                            rou: null,
                            errorMessage: "You have no permission on new destination"
                        })
                    }
                }
                else {
                    this.setState({
                        selectedTargetDivision: "",
                        isCheckingDepartment: false,
                        rou: null,
                        errorMessage: "Invalid department"
                    })
                }

            }) :
            this.setState({
                errorMessage: "Please input a department name"
            });
    }

    move() {
        this.props.move();
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps, { confirmDialog, showDialog, showToastMessage }, null, { forwardRef: true })(MoveReport_MoveInformation);